import { combineReducers } from '@reduxjs/toolkit';

import { pastAppointmentsReducer, PastAppointmentsState } from './pastAppointments/reducers';
import {
  upcomingAppointmentsReducer,
  UpcomingAppointmentsState
} from './upcomingAppointments/reducers';

export type AppointmentsState = {
  past: PastAppointmentsState;
  upcoming: UpcomingAppointmentsState;
};

const appointmentsReducer = combineReducers({
  past: pastAppointmentsReducer,
  upcoming: upcomingAppointmentsReducer
});

export default appointmentsReducer;
